import React from "react";

const WelcomeText = (props) => {
  return (
    <section className="welcome-slack-text">
      <h2 className="headline-4">Welcome, {props.userName}</h2>
      <p className="dashboard-welcome-message">{props.welcomeText}</p>
    </section>
  );
};

export default WelcomeText;
